<template>
  <div v-bem class="row">
    <div class="col-8 col-t-7"><Form @next-step="$emit('next-step')" /></div>
    <div class="col-4 col-t-5">
      <RecapBox page="account" :step="step" />
      <p v-if="$store.state.mensualite" class="rci_text">{{$t('steps.recap.rci')}}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: ['step'],
  name: 'Account',
  components: {
    RecapBox: () => import('@/components/RecapBox.vue'),
    Form    : () => import('@/components/Form.vue')
  }
}
</script>

<style lang="scss">
.account {
  padding: 0 rem(8);
  .rci_text {
    @include font-size(12);
    color: $dark-gray;
    text-align: center;
    margin-top: rem(8);
  }
  .recap-box .button.button--rci {
    display: none;
  }
}
</style>